module.exports = __webpack_public_path__ + "assets/img/650100.3da43f7d.png";